import {createApp} from 'vue'
import './style.css'
import App from './App.vue'
import router from "./router.ts";
import {i18n} from "./localization/localization.ts";
import adapter from 'webrtc-adapter';
import {logger, LogLevel} from "./utils/logger.ts";
// import * as Sentry from '@sentry/vue';

// Set app name from environment
const appName = (process.env.APP_NAME as string) || 'YourTeams';
const appShortName = (process.env.APP_SHORT_NAME as string) || 'YourTeams';
document.title = appName;

// Update manifest dynamically
const updateManifest = () => {
    const manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;
    if (manifestLink) {
        // Use absolute URLs for icons (required when manifest is served from blob URL)
        const origin = window.location.origin;
        const manifest = {
            name: appName,
            short_name: appShortName,
            icons: [
                {src: `${origin}/android-chrome-192x192.png`, sizes: "192x192", type: "image/png"},
                {src: `${origin}/android-chrome-512x512.png`, sizes: "512x512", type: "image/png"}
            ],
            theme_color: "#ffffff",
            background_color: "#ffffff",
            display: "standalone"
        };
        const blob = new Blob([JSON.stringify(manifest)], {type: 'application/json'});
        const manifestURL = URL.createObjectURL(blob);
        manifestLink.href = manifestURL;
    }
};
updateManifest();

// Configure logger level based on debug query parameter
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('debug') === 'true') {
    logger.setLevel(LogLevel.DEBUG);
}

logger.info('main', `App: ${appName}, Browser: ${adapter.browserDetails.browser}:${adapter.browserDetails.version}`)

const app = createApp(App)

/*
Sentry.init({
    app,
    dsn: 'https://27249745a0b644628ebe9d997510d373@app.glitchtip.com/8557',
    integrations: [Sentry.browserTracingIntegration({router}), Sentry.replayIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        "localhost",
        // "https://yourteams.org",
        // "https://stage.yourteams.org",
        // "https://b1.yourteams.org",
        // "https://b2.yourteams.org",
        // "https://b3.yourteams.org"
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});
*/
app.use(router)
app.use(i18n)
app.mount('#app')

